import { CREDENTIALS } from '../constants';
import {
  FULL_CATERING_ACCESS,
  NO_CATERING_ACCESS,
  cateringAccessOf,
  isCateringAdminRole,
  type CateringAccess,
} from './cateringAccessPermissions';

/* ---------- Catering permissions read (same approach as Kiosk Media, commit 2db9e26d4) ---------- */

function storedCredentials(): { outer: any; cred: any } | null {
  try {
    const raw = localStorage.getItem(CREDENTIALS);
    if (!raw) return null;
    const stored = JSON.parse(raw);
    return { outer: stored, cred: stored?.credentials ?? stored };
  } catch {
    return null;
  }
}

function tokenOf(cred: any): string | null {
  const token = cred?.accessToken ?? cred?.access_token ?? cred?.token ?? cred?.idToken ?? cred?.id_token ?? cred?.jwtToken ?? cred?.jwt;
  return typeof token === 'string' && token.trim() ? token.trim() : null;
}

/**
 * The signed-in employee's Catering permissions, read fresh on every call (POST /merchants/staff/permissions),
 * so a change made in Employees applies without logging in again.
 */
export async function getCateringAccess(): Promise<CateringAccess> {
  const stored = storedCredentials();
  if (!stored) return NO_CATERING_ACCESS;
  const { outer, cred } = stored;
  const pick = (...keys: string[]) => keys.map((k) => outer?.[k] ?? cred?.[k]).find((v) => v != null && v !== '');

  // Brisque Admin: no Catering restriction at all (role or designation, any case / spacing).
  if (isCateringAdminRole(pick('role'), pick('designation'))) return FULL_CATERING_ACCESS;
  const staffId = pick('staff_id', 'staffId', 'id');
  const merchantId = pick('merchantId');
  if (!staffId || !merchantId) return NO_CATERING_ACCESS;

  // Loaded on first use: the signed-request client (HMAC / TextEncoder) is only needed when the read actually runs.
  const { getStaffPermissions } = await import('./api');
  const res = await getStaffPermissions({ staffId: String(staffId), merchantId: String(merchantId), token: tokenOf(cred) ?? undefined });
  return cateringAccessOf(res);
}
